var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15.17 22",
    id: "svg13",
    width: 15.17,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g13",
    transform: "translate(-9.96,-39.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 11.83,49.34 c 0.55,0.2 1.13,0.3 1.72,0.3 0.59,0 1.17,-0.1 1.72,-0.3 0.17,0.29 0.25,0.62 0.25,0.97 v 7.93 c 0,1.09 -0.89,1.98 -1.98,1.98 -1.09,0 -1.98,-0.89 -1.98,-1.98 v -7.93 c 0,-0.35 0.09,-0.68 0.25,-0.97 m 3.78,-1.84 c -0.58,0.4 -1.28,0.64 -2.04,0.64 -0.76,0 -1.46,-0.24 -2.04,-0.64 -0.87,0.63 -1.43,1.66 -1.43,2.81 v 7.93 c 0,1.92 1.56,3.48 3.48,3.48 v 0 c 1.92,0 3.48,-1.56 3.48,-3.48 v -7.93 c 0,-1.16 -0.57,-2.18 -1.43,-2.81 v 0 z",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 13.55,41.22 c 1.15,0 2.09,0.94 2.09,2.09 0,1.15 -0.94,2.09 -2.09,2.09 -1.15,0 -2.09,-0.94 -2.09,-2.09 0,-1.15 0.94,-2.09 2.09,-2.09 m 0,-1.5 c -1.98,0 -3.59,1.61 -3.59,3.59 0,1.98 1.61,3.59 3.59,3.59 1.98,0 3.59,-1.61 3.59,-3.59 0,-1.98 -1.61,-3.59 -3.59,-3.59 z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 23.26,53.23 c 0.15,0.26 0.24,0.56 0.25,0.86 0,0.02 0,0.03 0,0.05 v 4.1 c 0,1.09 -0.89,1.98 -1.98,1.98 -1.09,0 -1.98,-0.89 -1.98,-1.98 v -4.04 0 c 0,0 0,-0.05 0,-0.07 0.01,-0.32 0.1,-0.63 0.25,-0.91 0.55,0.2 1.13,0.3 1.72,0.3 0.59,0 1.17,-0.1 1.72,-0.3 m 0.34,-1.83 c -0.58,0.4 -1.28,0.64 -2.04,0.64 -0.76,0 -1.46,-0.24 -2.04,-0.64 -0.84,0.61 -1.39,1.59 -1.43,2.7 v 0 4.15 c 0,1.92 1.56,3.48 3.48,3.48 v 0 c 1.92,0 3.48,-1.56 3.48,-3.48 v -4.23 0 C 24.97,52.93 24.42,51.98 23.6,51.39 v 0 z",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 21.54,45.11 c 1.15,0 2.09,0.94 2.09,2.09 0,1.15 -0.94,2.09 -2.09,2.09 -1.15,0 -2.09,-0.94 -2.09,-2.09 0,-1.15 0.94,-2.09 2.09,-2.09 m 0,-1.5 c -1.98,0 -3.59,1.61 -3.59,3.59 0,1.98 1.61,3.59 3.59,3.59 1.98,0 3.59,-1.61 3.59,-3.59 0,-1.98 -1.61,-3.59 -3.59,-3.59 z",
    id: "path10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuo);
export default __webpack_public_path__ + "static/media/Duo.d0ecc3afe744337ac9e325558a1caf20.svg";
export { ForwardRef as ReactComponent };